'use client';

export { default } from './Checkbox';
export { default as checkboxClasses } from './checkboxClasses';
export * from './checkboxClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Checkbox/index.js
// module id = 505
// module chunks = 25